import { CultureInfo } from '../culture-info.model';
import { CultureInfoAr } from './ar';

/**
 * @ignore
 */
export const CultureInfoAr001: CultureInfo = {
  name: 'ar-001',
  displayName: 'العربية (العالم)',
  iso3LanguageCode: 'ara',
  iso2LanguageCode: 'ar',
  ietfLanguageTag: 'ar-001',
  parent: CultureInfoAr
};
